import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { whatsAppSimple } from "../lib/api";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-vm-border" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="font-serif text-3xl tracking-[0.25em]">VELMONTÉ</div>
            <p className="vm-label mt-3">{t("brand.tagline")}</p>
            <p className="text-vm-accent text-xs tracking-[0.25em] uppercase mt-6">{t("footer.tagline")}</p>
          </div>
          <div className="flex flex-col gap-3 text-sm text-vm-text2">
            <a href={whatsAppSimple()} target="_blank" rel="noopener noreferrer" className="vm-link" data-testid="footer-whatsapp">{t("common.whatsapp")}</a>
            <a href="tel:+34645459043" className="vm-link" data-testid="footer-call">{t("common.call")} · +34 645 459 043</a>
            <a href="mailto:office@velmonte.com" className="vm-link" data-testid="footer-email">office@velmonte.com</a>
            <Link to="/services" className="vm-link" data-testid="footer-services-en">Services &amp; destinations</Link>
            <Link to="/es/servicios" className="vm-link" data-testid="footer-services-es">Servicios y destinos</Link>
          </div>
        </div>
        <div className="vm-hairline my-10" />
        <div className="flex flex-col sm:flex-row justify-between gap-3 text-[0.7rem] tracking-widest uppercase text-vm-muted">
          <span>© {year} VELMONTÉ · {t("footer.rights")}</span>
          <span>{t("common.availability")}</span>
        </div>
      </div>
    </footer>
  );
};
